// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"e2b7faf5","110":"b2f1b843","169":"0c035f59","231":"7c4c81e0","294":"2bbc5458","351":"f556b687","365":"77aa89cf","401":"faf27a38","453":"cfd59cba","492":"0a301678","640":"23dc8933","669":"372b36e8","772":"1c717f7b","881":"1f605fa7","946":"201b42c9","963":"f0f5fcb8"}[chunkId] + ".chunk.js";
};